// containers
import { Navigation } from '@/containers-m/Navigation';
import { Footer } from '@/containers-m/Footer';

//context containers
import {
  Hero,
  WhatWeDo,
  Mission,
  Differentiators,
  WhoUses,
  Team,
  HowItWorks,
  KeyFacts,
  Awards,
  FAQ,
  Careers,
} from './containers';

//styles
import { PageWrapper } from './About.styles';

function About({ content }) {
  return (
    <PageWrapper>
      <Navigation />
      <>
        <Hero content={content.hero} />
        <WhatWeDo content={content.what_we_do} />
        <Mission content={content.mission} />
        <Differentiators content={content.differentiators} />
        <WhoUses content={content.who_uses} />
        <Team content={content.team} />
        <HowItWorks content={content.how_it_works} />
        <KeyFacts content={content.key_facts} />
        <Awards content={content.awards} />
        <FAQ content={content.faq} />
        <Careers content={content.careers} />
      </>
      <Footer />
    </PageWrapper>
  );
}

export default About;
export { About };
